<div class="pcr-title-heading">Promo Claim Rate</div>
<div class="promo-claim-rate-container pcr-box">
  @if (loading()) {
    <mat-spinner [diameter]="20"></mat-spinner>
  }
  @if (loadFailed()) {
    <p class="promo-claim-rate-error" data-id="promoClaimRateError">Failed to load promotion claim rate</p>
  }
  @if (promoClaimRate(); as rate) {
    <div class="pcr-row">
      <span class="pcr-title">Promo Claim Rate =</span>
      <span class="pcr-indicator" data-id="promoClaimRateIndicator" [class]="'pcr-indicator ' + rate.indicator">
        {{ rate.indicator }}
      </span>
      <mat-icon
        class="pcr-info-icon"
        fontIcon="info_outline"
        data-id="promoClaimRateInfo"
        matTooltipClass="promo-claim-rate-tooltip"
        [matTooltip]="indicatorTooltip"></mat-icon>
    </div>
    <div class="pcr-detail">
      <span class="pcr-detail-label">Last updated:</span>
      <span data-id="promoClaimRateLastUpdated">{{
        (lastUpdated() | date: 'dd MMM yyyy HH:mm:ss' : '+0000') || '-'
      }}</span>
    </div>
    <div class="pcr-detail">
      <span class="pcr-detail-label">Status trigger:</span>
      <span data-id="promoClaimRateTrigger">{{ statusTrigger() }}</span>
    </div>
    <div>
      @if (rate.overridden && rate.override) {
        <div class="pcr-detail">
          <span class="pcr-detail-label">Override reason:</span>
          <span data-id="promoClaimRateReason">{{ rate.override.reason }}</span>
        </div>
        <div class="pcr-detail">
          <span class="pcr-detail-label">Overridden by:</span>
          <span>{{ rate.override.authorEmail }}</span>
        </div>
      }
      @if (rate.calculated) {
        <div class="pcr-detail pcr-calculated">
          <span class="pcr-detail-label">Calculated:</span>
          <span>
            {{ rate.calculated.indicator }} ({{ rate.calculated.claimRatePercentage }}% –
            {{ rate.calculated.qualifiedPromotionsCount }} qualified promotions /
            {{ rate.calculated.depositsCount }} deposits)
          </span>
        </div>
      }
    </div>
  }
</div>
